// Repete uma operação assíncrona com backoff exponencial.
//
// DTGD-1535: usado no registro da baixa do PIX. A baixa é postada uma única vez,
// pelo front, no momento em que o pagamento é detectado — se aquele POST falha
// (timeout de 10s do axios, 5xx, rede oscilando no celular), o título fica em
// aberto mesmo com o PIX liquidado. Uma tentativa só é pouco para algo que não
// tem segunda chance dentro da sessão.
//
// `sleep` é injetável para o teste não precisar esperar de verdade.
const defaultSleep = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export default async function retryAsync(
  fn,
  { attempts = 3, delayMs = 1000, sleep = defaultSleep } = {},
) {
  let lastError;

  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      // eslint-disable-next-line no-await-in-loop
      return await fn(attempt);
    } catch (error) {
      lastError = error;
      if (attempt < attempts) {
        // Backoff exponencial: 1s, 2s, 4s... Espalha as tentativas o suficiente
        // para atravessar uma indisponibilidade curta sem prender o usuário.
        // eslint-disable-next-line no-await-in-loop
        await sleep(delayMs * 2 ** (attempt - 1));
      }
    }
  }

  throw lastError;
}
